import type { SceneBeat } from "@/lib/timeline/book/BookLayout";
import { activeBeatIndex } from "@/lib/timeline/playback";

export const MARKER_SCENE_FADE_MS = 650;

/** Playhead time for a newcomer to move from the center into their seat. */
export const MARKER_JOIN_MS = 2400;

export function markerPresenceOpacity(
  characterId: string,
  playheadMs: number,
  beats: SceneBeat[],
): number {
  const beatIndex = activeBeatIndex(beats, playheadMs);
  if (beatIndex < 0) {
    return 0;
  }
  const beat = beats[beatIndex];
  const inScene = beat.characterIds.includes(characterId);
  const localMs = playheadMs - beat.startMs;
  const untilEndMs = beat.endMs - playheadMs;

  if (inScene) {
    let opacity = 1;
    const prev = beatIndex > 0 ? beats[beatIndex - 1] : undefined;
    if (
      prev !== undefined &&
      !prev.characterIds.includes(characterId) &&
      localMs < MARKER_JOIN_MS
    ) {
      opacity = Math.min(opacity, localMs / MARKER_JOIN_MS);
    }
    const next =
      beatIndex < beats.length - 1 ? beats[beatIndex + 1] : undefined;
    if (
      next !== undefined &&
      !next.characterIds.includes(characterId) &&
      untilEndMs < MARKER_SCENE_FADE_MS
    ) {
      opacity = Math.min(opacity, untilEndMs / MARKER_SCENE_FADE_MS);
    }
    return clamp01(opacity);
  }

  const prev = beatIndex > 0 ? beats[beatIndex - 1] : undefined;
  if (
    prev !== undefined &&
    prev.characterIds.includes(characterId) &&
    localMs < MARKER_SCENE_FADE_MS
  ) {
    return clamp01(1 - localMs / MARKER_SCENE_FADE_MS);
  }

  return 0;
}

function clamp01(value: number): number {
  return Math.min(1, Math.max(0, value));
}
